import { render, staticRenderFns } from "./feeInitializationList.vue?vue&type=template&id=3250b6ae&"
import script from "./feeInitializationList.vue?vue&type=script&lang=js&"
export * from "./feeInitializationList.vue?vue&type=script&lang=js&"
import style0 from "./feeInitializationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports